export enum ManifestConversationType {
  Recall = 'RC',
  Marketing = 'MA',
}
